<template>
    <div class="c-modal__mask hcp-only" :class="{'main-popup': activeForHcpOnly}" v-if="showOnlyForHcpPopup && isHcpOnlyPopupVisible">
        <div class="c-modal__wrapper">
			<DsText
				html-element="div"
				text-type="body-lg">
				<div v-html="this.vm.BaseViewModel.ActiveForHcpOnlyText" />
			</DsText>
			<DsButtonGroup mobile-direction="column">
				<DsButton @click="setIsHealthCareProfessional" variant="primary" icon-end="navigate-forward">{{this.vm.BaseViewModel.ApproveForHcpOnlyButtonText}}</DsButton>
				<DsButton @click="goBackOrHideButtons" variant="primary" >{{this.vm.BaseViewModel.RejectForHcpOnlyButtonText}}</DsButton>
			</DsButtonGroup>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DsButton, DsButtonGroup, DsText } from '@coloplast/design-system';

export default {
    name: "hcp-popup",
    props: {
        vm: {
            type: Object,
            required: true,
        },
        activeForHcpOnly: {
            type: Boolean,
            default: false,
        },
        disableHcpOnlyValidation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isHcpOnlyPopupVisible: true,
            isHealthCareProfessional: localStorage.getItem('isHealthCareProfessional') != null ? JSON.parse(localStorage.getItem('isHealthCareProfessional')) : false,
        }
    },
	components: {
		DsButton,
		DsButtonGroup,
		DsText,
	},
    computed: {
        ...mapGetters({
            selectedVariant: 'getSelectedVariant',
        }),
        showOnlyForHcpPopup() {
            return !this.disableHcpOnlyValidation && this.activeForHcpOnly && !this.isHealthCareProfessional || this.selectedVariant && this.selectedVariant.Item.ActiveForHcpOnly && !this.isHealthCareProfessional && !this.activeForHcpOnly;
        },
    },
    methods: {
        changeHcpPopupstate() {
            this.isHcpOnlyPopupVisible = false
        },
        goBackOrHideButtons() {
            (document.referrer.indexOf(window.location.host) != -1) ? window.history.go(-1) : this.changeHcpPopupstate()
        },
        setIsHealthCareProfessional() {
            this.isHealthCareProfessional = true;
            localStorage.setItem('isHealthCareProfessional', true);
        },
    }
}
</script>
